import React from "react";
import {GridCell, gridConstants, GridContainer} from "../Grid";
import {LinkButton} from "../Link";
import {locations} from "../../Utilities/Location";
import {getFullName, isLoggedIn} from "../../Utilities/LocalStorage/storageUtilities";
import {createMenuItem, ProfileMenu} from "../ProfileMenu";
import {passwordApi} from "../../Containers/Password/passwordApi";
import {SYSTEM_TYPES} from "../../Containers/Library/libraryConstants";
import {getSystemTypeTextByValue} from "../../Containers/Library/libraryUtility";
import type {HandleApiCall, User} from "../../types";

interface HeaderNavProps {
    handleApiCall: HandleApiCall;
    location?: { pathname: string };
    redirect?: (path: string) => void;
    showCatalogLink?: boolean;
    showAphCatalogLink?: boolean;
    showLoanLibraryCatalogLink?: boolean;
    showBraillerCatalogLink?: boolean;
    systemType?: string;
    systemTypeText?: string;
    user?: User;
}

export const HeaderNav: React.FC<HeaderNavProps> = ({
                              handleApiCall,
                              location = {pathname: ""},
                              redirect,
                              showCatalogLink,
                              showAphCatalogLink,
                              showLoanLibraryCatalogLink,
                              showBraillerCatalogLink,
                              systemType,
                              systemTypeText,
                              user,
                          }) => {

    const isDashboardPage = location.pathname === locations.DASHBOARD.path;
    const isLandingPage = location.pathname === locations.LANDING.path;
    const isUserLoggedIn = isLoggedIn();

    const handleUpdatePassword = async (email: string) => {
        return handleApiCall(() => passwordApi.forgotPassword(email));
    };

    const profileLabel = isUserLoggedIn ? getFullName() : null;
    const menuItems = isUserLoggedIn ? [
        createMenuItem(`Update Profile`, () => redirect!(locations.USER_PROFILE.getPath(user!.userId))),
        createMenuItem(`Update Password`, () => handleUpdatePassword(user!.email)),
        createMenuItem(`Sign out`, () => redirect!(locations.SIGN_OUT.path)),

    ] : null;

    return (
        <nav className="headerNav">
            <GridContainer hasMarginX>
                <GridCell small_columns={gridConstants.column.SIX}>
                    {
                        isUserLoggedIn &&
                        <ProfileMenu menuItems={menuItems!} profileLabel={profileLabel!}/>
                    }
                </GridCell>
                <GridCell small_columns={gridConstants.column.SIX}>
                    {
                        !isUserLoggedIn && !isLandingPage &&
                        <LinkButton {...locations.LANDING.link} />
                    }
                    {
                        !showCatalogLink && !showAphCatalogLink && !showLoanLibraryCatalogLink && !showBraillerCatalogLink && !isDashboardPage && isUserLoggedIn &&
                        <LinkButton {...locations.DASHBOARD.link} />
                    }
                    {
                        showCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.LIBRARY_CATALOG.getLink(systemType)} label={systemTypeText} />
                    }
                    {
                        showAphCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.APH_CATALOG.getLink(SYSTEM_TYPES.APH)} label={getSystemTypeTextByValue(SYSTEM_TYPES.APH.toString())} />
                    }
                    {
                        showLoanLibraryCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.LOAN_LIBRARY_CATALOG.link} label="Loan Library" />
                    }
                    {
                        showBraillerCatalogLink && isUserLoggedIn &&
                        <LinkButton {...locations.BRAILLER_CATALOG.link} label="Brailler Catalog" />
                    }
                </GridCell>
            </GridContainer>
        </nav>
    );
};
